module.exports = __webpack_public_path__ + "img/email.91cc125c.png";